
// require('jquery-touch-events');
require('lightcase');

module.exports = function () {
    $(document).ready(function () {

        $('[data-lightbox]').lightcase({
            attr:               'data-lightbox',
            transition:         'scrollHorizontal',
            showSequenceInfo:   true,
            //showCaption:      false,
            maxWidth:           1300,
            maxHeight:          900,
            overlayOpacity:     0.55
        });

        $('.Image__download').on('click', function (e) {
            e.stopPropagation();
            var link = $(this).data('download');
            window.location.assign(link)
            return false;
        });

    });
};
